import { HttpClient } from "@angular/common/http";
import { DatabaseService } from "src/app/servicios/database/database.service";

export class CkUploadAdapter {
  constructor(
    private loader: any,
    private http: HttpClient,
    private databaseService: DatabaseService
  ) {}
  upload() {
    return this.loader.file.then((file) => {
      let formData: FormData = new FormData();
      formData.append("file", file);

      return new Promise((resolve, reject) => {
        this.loader.uploadTotal = 0;
        this.http
          .post(`${this.databaseService.baseUrl}/upload_help_img`, formData)
          .subscribe({
            next: (result: { message: string; url: string }) => {
              resolve({
                default: result.url,
              });
              this.loader.uploaded = true;
            },
            error: (error) => reject(error),
          });
      });
    });
  }
  abort() {
    console.error("aborted");
  }
}
